
const openSocialLoginModal = () => {
    // Modal for alert about existent current user with same email
    const oauthWrapper = $('.oauth-wrapper');
    if (oauthWrapper.length) {
        oauthWrapper.modal('show');

        const url = new URL(window.location.href);
        url.searchParams.delete('oauth');
        window.history.replaceState(null, null, url);

        oauthWrapper.on('hidden.bs.modal', () => {
            const ajaxUrl = oauthWrapper.attr('data-url');

            $.ajax({
                url: ajaxUrl,
                method: 'GET',
            });
        });
    }
};

module.exports = {
    openSocialLoginModal,
};
